import CampaignSection from "../components/credit-bonus/campaignSection";
import { Hero } from "../layouts/hero";
import { MainLayout } from "../layouts/mainLayout";

function CreditBonus() {
  return (
    <MainLayout>
      <div className="main">
        <Hero
          title="Credit Bonus"
          logo={false}
          desc="Create and track Credit Bonus campaigns."
        />
        <CampaignSection />
      </div>
    </MainLayout>
  );
}

export default CreditBonus;
